



























import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";
import RadialChart from "@/components/layout/charts/radial/RadialChart.vue";
import TrendCard from "@/components/core/nodes/partials/TrendCard.vue";
import LineChart from "@/components/layout/charts/line/LineChart.vue";
import StatModule from "@/store/modules/StatModule";
import { resolveModule } from "@/store";
import { StatFetchingData } from "@/dto/Stat/StatFetchingData";
import NodeOverviewService from "@/services/nodeoverview/NodeOverviewService";
import ContentCard from "@/components/layout/cards/ContentCard.vue";
import StatisticTrendCard from "@/components/core/nodes/partials/StatisticTrendCard.vue";
import axios from "axios";
import moment from "moment-timezone";
import NodeModule from "@/store/modules/NodeModule";

@Component({
  components: {
    "content-card": ContentCard,
    "trend-card": TrendCard,
    "radial-chart": RadialChart,
    "line-chart": LineChart,
    "statistic-trend-card": StatisticTrendCard,
  },
})
export default class NodeOverview extends Vue {
  @Prop({})
  private readonly locationId!: number;

  @Prop({})
  private readonly average!: boolean;

  private stats: any = {
    availability: 0,
    efficiency: 0,
    quality: 0,
    oee: 0,
  };

  private readonly statModule: StatModule = resolveModule(StatModule);
  private readonly nodeModule: NodeModule = resolveModule(NodeModule);

  private get nodeId(): number {
    return +this.$route.params.nodeId;
  }

  private get Stat(): NodeOverviewService {
    return this.statModule.StatByNodeId(this.nodeId);
  }

  private get characteristic() {
    if (this.average) {
      return this.nodeModule.characteristic;
    } else {
      return this.nodeModule.characteristicSingle;
    }
  }

  private availability: number[] = [];
  private efficiency: number[] = [];
  private quality: number[] = [];
  private oee: number[] = [];
  private arrayStats: number[] = [];

  private calculateAverage(data: number[]) {
    const arrayLength = Math.max(...this.arrayStats);
    const reverseData = data.reverse();
    reverseData.length = arrayLength + 1;
    return reverseData.reduce((a: any, b: any) => (a + b)) / reverseData.length;
  }

  @Watch("characteristic")
  public async pullPage(characteristic: any) {
    if (this.average) {
      characteristic.forEach((item: any, i: number) => {
        this.availability.push(item.availability);
        this.efficiency.push(item.efficiency);
        this.quality.push(item.quality);
        this.oee.push(item.oee);
        this.arrayStats.push(i);
      });
      this.stats.availability = this.calculateAverage(this.availability);
      this.stats.efficiency = this.calculateAverage(this.efficiency);
      this.stats.quality = this.calculateAverage(this.quality);
      this.stats.oee = this.calculateAverage(this.oee);
    } else {
      this.stats = characteristic;
    }
  }

  public async mounted(): Promise<void> {
    const payload = new StatFetchingData();
    payload.nodeId = this.nodeId;
    await this.statModule.Fetch(payload);
    await this.nodeModule.fetchCharacteristicSingle(this.$route.params.nodeId);
  }
}
